"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyI18nService = void 0;
var intl_messageformat_1 = __importDefault(require("intl-messageformat"));
var LegacyI18nService = /** @class */ (function () {
    function LegacyI18nService() {
        // default value is browser language.
        this.lang = 'en';
        return this;
    }
    /**
     * set current language
     *
     * @param {string} langCode like "en-US"
     */
    LegacyI18nService.prototype.setLang = function (langCode) {
        // redefine language
        this.lang = langCode;
    };
    LegacyI18nService.prototype.getLang = function () {
        return this.lang;
    };
    LegacyI18nService.prototype.getKeyFromOnePackage = function (icuKey, langDefine, locate) {
        var locateCode = locate;
        var resultKey = '';
        if (langDefine[locateCode]) {
            if (langDefine[locateCode][icuKey]) {
                resultKey = langDefine[locateCode][icuKey];
            }
        }
        /* remove the logic by business
        if (locateCode.lastIndexOf('-') > 0) {
            locateCode = locateCode.substr(0, locateCode.lastIndexOf('-'));
            return this.getLocateKey(icuKey, langDefine, locateCode);
        } */
        if (!resultKey && locate !== 'en') {
            resultKey = this.getKeyFromOnePackage(icuKey, langDefine, 'en');
        }
        return resultKey;
    };
    LegacyI18nService.prototype.getLocateKey = function (icuKey, langDefines, locate) {
        var resultKey = '';
        if (!langDefines || langDefines.length === 0) {
            return icuKey;
        }
        // tslint:disable-next-line prefer-for-of
        for (var i = 0; i < langDefines.length; i += 1) {
            resultKey = this.getKeyFromOnePackage(icuKey, langDefines[i], locate);
        }
        if (!resultKey) {
            resultKey = icuKey;
        }
        return resultKey;
    };
    /**
     * format ICU key to string
     *
     * @param {string} key The Key
     * @param {object} [values] key-values object
     * @param {array} [langs] language resources
     * @param {string} [locate] like"en-US"
     * @param {object} [options] special number options https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/GlobalTranslate_Objects/NumberFormat
     * @returns {string} the result of the translate
     * @example
     * // Data
     * Translate.format('Coupon expires at {expires,time,long }', { expires: new Date() })
     * // Currency
     * Translate.format('The price is: {price, number, USD}', { price: 1000.856 }, 'en-US', {
     *      number: {
     *          USD: {
     *              style: 'currency',
     *              currency: 'USD'
     *          }
     *      }
     *  });
     *  // {plural} Format
     *  Translate.format(`It's my cat's {year, selectordinal,
     *          one {#st}
     *          two {#nd}
     *          few {#rd}
     *          other {#th}
     *      } birthday!`, { year: 2 });
     *  // {select} format
     *  Translate.format('{gender, select,
     *          male {He}
     *          female {She}
     *          other {They}
     *          } will respond shortly', { gender: 'male' })
     *  // {selectordinal} Format
     *  Translate.format('You have {numPhotos,plural,
     *      =0 {no photos.}
     *      =1 {one photo.}
     *      other {# photos.}}', { numPhotos: 1000 }, NewsCenterLangs);
     */
    LegacyI18nService.prototype.format = function (icuKey, values, langs, custLang) {
        var key = '';
        var langDefines = langs;
        var locateCode = custLang || this.lang;
        key = this.getLocateKey(icuKey, langDefines, locateCode);
        var message = new intl_messageformat_1.default(key, locateCode, {});
        return message.format(values);
    };
    return LegacyI18nService;
}());
exports.LegacyI18nService = LegacyI18nService;
//# sourceMappingURL=LegacyI18nService.js.map